import AdvancedSelect from "@edaz/edazkit/controls/AdvancedSelect";
import DateRangeInputControl from "controls/dateRangeInput";
import { observer } from "mobx-react-lite";
import React from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import { translateGeneral } from "utils/localizations";
import FilterView from "../../common/filter";
import type OutagesViewModel from "viewModels/administration/outages/outagesViewModel";

export interface OutageFiltersProps {
  vm: OutagesViewModel;
}

const OutageFilters = observer((props: OutageFiltersProps) => {
  const { vm } = props;

  return (
    <FilterView vm={vm}>
      <div className="row">
        <Form.Group as={Col} lg={8} xl={6}>
          <Form.Label>{vm.translateFilterAttribute("validity")}</Form.Label>
          <DateRangeInputControl target={vm.filter} property="validity" />
        </Form.Group>
        <Form.Group as={Col} lg={8} xl={6}>
          <Form.Label>{vm.translateFilterAttribute("visibility")}</Form.Label>
          <DateRangeInputControl target={vm.filter} property="visibility" />
        </Form.Group>
        <Form.Group as={Col} md={6} lg={4} xl={3}>
          <Form.Label>{vm.translateFilterAttribute("systemComponentId")}</Form.Label>
          <AdvancedSelect
            target={vm.filter}
            property="systemComponentId"
            items={vm.systemComponentOptions}
            allowEmpty={true}
            placeholder={translateGeneral("select")}
          />
        </Form.Group>
        <Form.Group as={Col} md={6} lg={4} xl={3}>
          <Form.Label>{vm.translateFilterAttribute("state")}</Form.Label>
          <AdvancedSelect
            target={vm.filter}
            property="state"
            items={vm.stateOptions}
            allowEmpty={true}
            placeholder={translateGeneral("select")}
          />
        </Form.Group>
        <Form.Group as={Col} md={6} lg={4} xl={3}>
          <Form.Label>{vm.translateFilterAttribute("includeDeleted")}</Form.Label>
          <AdvancedSelect
            target={vm.filter}
            property="includeDeleted"
            items={vm.booleanOptions}
            allowEmpty={true}
            placeholder={translateGeneral("select")}
          />
        </Form.Group>
      </div>
    </FilterView>
  );
});

export default OutageFilters;
